/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationForGcpKubernetesUserManagedOnboarded extends models.StorageConfigurationForGcpKubernetesUserManaged {
    constructor() {
        super();
        this.setDiscriminator("StorageConfigurationForGcpKubernetesUserManagedOnboarded");
    }

    getFixupPrototypeFunction() { return StorageConfigurationForGcpKubernetesUserManagedOnboarded.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationForGcpKubernetesUserManagedOnboarded>): StorageConfigurationForGcpKubernetesUserManagedOnboarded {
        let obj = Object.assign(new StorageConfigurationForGcpKubernetesUserManagedOnboarded(), model);
        StorageConfigurationForGcpKubernetesUserManagedOnboarded.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationForGcpKubernetesUserManagedOnboarded>): StorageConfigurationForGcpKubernetesUserManagedOnboarded {
        if (!model) return null;
        return StorageConfigurationForGcpKubernetesUserManagedOnboarded.newInstance(<StorageConfigurationForGcpKubernetesUserManagedOnboarded> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationForGcpKubernetesUserManagedOnboarded) {
        if (!obj) return;

        models.StorageConfigurationForGcpKubernetesUserManagedOnboarded.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationForGcpKubernetesUserManagedOnboarded): boolean {
        if (models.StorageConfigurationForGcpKubernetesUserManaged.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, StorageConfigurationForGcpKubernetesUserManagedOnboarded.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Reference to the Service Account under which the GCS bucket is present.
     */
    account_id: string;

}
